import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const api = new AxiosInterceptor();
const prefix = "/subscriptions";

export default {
  find(id) {
    return api.get("/subscriptions/" + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/subscriptions?" + qstr);
  },
  delete(id) {
    return api.delete("/subscriptions/" + id);
  },
  create(inputs) {
    return api.post("/subscriptions", inputs);
  },
  update(id, inputs) {
    return api.put("/subscriptions/" + id, inputs);
  },
  addCampaign(id, inputs) {
    return api.post(`/subscriptions/${id}/add-campaign`, inputs);
  },
  stopCampaign(id) {
    return api.delete(`/subscriptions/${id}/stop-campaign`);
  },
  getSubsCampaignHistory(id) {
    return api.get(`${prefix}/${id}/campaigns`);
  },
  getSearchSub(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/subscriptions/search?" + qstr);
  },
  changePlan(id, inputs) {
    return api.put(`/subscriptions/${id}/change-plan`, inputs);
  },
};
